$(function () {
  let $selectAllCheckbox = $(".js-select-all");
  let $selectedCountElement = $(".js-selected-count");
  let $addToCartSelectedBtn = $(".js-add-to-cart-selected");
  let $removeSelectedBtn = $(".js-remove-selected");

  function init() {
    bindEvents();
    updateSelectedCount();
  }

  function bindEvents() {
    $selectAllCheckbox.on("change", handleSelectAll);
    $(document).on("change", ".js-select-item", handleItemSelection);
    $(document).on("click", ".js-decrease-qty", handleDecreaseQuantity);
    $(document).on("click", ".js-increase-qty", handleIncreaseQuantity);
    $(document).on("click", ".js-add-to-cart-selected", handleAddToCartSelected);
    $(document).on("click", ".js-remove-selected", handleRemoveSelected);
    $(document).on("click", ".js-remove-all", handleRemoveAll);
    $(document).on("click", ".productDetail__buyBtn", handleBuyNow);
  }

  function handleBuyNow(e) {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const productId = $btn.data("id") || getProductId($btn);
    const $row = $btn.closest(".wishlist-table__row");
    const quantity = parseInt($row.find(".js-quantity-input").val() || 1);

    if (!productId) return;

    $btn.prop("disabled", true).addClass("button-loading");

    $.ajax({
      url: window.siteUrl + "/cart/add-to-cart",
      method: "POST",
      data: {
        id: productId,
        qty: quantity,
        checkout: 1,
      },
      dataType: "json",
      success: (res) => {
        $btn.prop("disabled", false).removeClass("button-loading");
        if (res.error) {
          Theme.showError(res.message);
          if (res.data.next_url !== undefined) {
            window.location.href = res.data.next_url;
          }
          return;
        }

        if (res.data.next_url !== undefined) {
          window.location.href = res.data.next_url;
        } else {
          window.location.href = window.siteUrl + "/checkout";
        }
      },
      error: (res) => {
        $btn.prop("disabled", false).removeClass("button-loading");
        Theme.showError(res.responseJSON?.message || "Something went wrong");
      },
    });
  }

  function handleRemoveSelected(e) {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const selectedIds = $(".js-select-item:checked")
      .map(function () {
        return $(this).val();
      })
      .get();

    if (selectedIds.length === 0) return;

    if (!confirm(window.Trans["confirm_remove_selected"] || "Are you sure you want to remove selected items?")) {
      return;
    }

    $btn.prop("disabled", true).addClass("button-loading");

    const removeNextProduct = (index) => {
      if (index >= selectedIds.length) {
        $btn.prop("disabled", false).removeClass("button-loading");
        Theme.showSuccess(window.Trans["removed_selected_success"] || "Selected products removed from wishlist");
        updateSelectedCount();
        checkEmptyState();
        return;
      }

      const productId = selectedIds[index];
      const $row = $(`.wishlist-table__row[data-product-id="${productId}"]`);
      const $removeBtn = $row.find(".wishlist-table-js-remove-item");
      const url = $removeBtn.data("url");

      $.ajax({
        url: url,
        method: "DELETE",
        success: (res) => {
          $row.remove();
          removeNextProduct(index + 1);
        },
        error: (res) => {
          console.error("Error removing product " + productId + " from wishlist", res);
          removeNextProduct(index + 1);
        },
      });
    };

    removeNextProduct(0);
  }

  function handleRemoveAll(e) {
    e.preventDefault();
    const $btn = $(e.currentTarget);

    if (!confirm(window.Trans["confirm_remove_all"] || "Are you sure you want to remove all items from your wishlist?")) {
      return;
    }

    $btn.prop("disabled", true).addClass("button-loading");

    $.ajax({
      url: $btn.data("url"),
      method: "DELETE",
      success: (res) => {
        $btn.prop("disabled", false).removeClass("button-loading");
        if (res.error) {
          Theme.showError(res.message);
          return;
        }

        Theme.showSuccess(res.message);
        $(".wishlist-table__row").remove();
        updateSelectedCount();
        checkEmptyState();
      },
      error: (res) => {
        $btn.prop("disabled", false).removeClass("button-loading");
        Theme.showError(res.responseJSON?.message || "Something went wrong");
      },
    });
  }

  function handleAddToCartSelected(e) {
    e.preventDefault();
    const $btn = $(e.currentTarget);
    const selectedIds = $(".js-select-item:checked")
      .map(function () {
        return $(this).val();
      })
      .get();

    if (selectedIds.length === 0) return;

    $btn.prop("disabled", true).addClass("button-loading");

    const addNextProduct = (index) => {
      if (index >= selectedIds.length) {
        $btn.prop("disabled", false).removeClass("button-loading");
        Theme.showSuccess(window.Trans["added_to_cart_success"] || "Selected products added to cart");
        updateCartDisplay();

        // Remove from wishlist after adding to cart
        selectedIds.forEach((id) => {
          const $row = $(`.wishlist-table__row[data-product-id="${id}"]`);
          $row.remove();
        });
        updateSelectedCount();
        checkEmptyState();

        return;
      }

      const productId = selectedIds[index];
      const $row = $(`.wishlist-table__row[data-product-id="${productId}"]`);
      const quantity = parseInt($row.find(".js-quantity-input").val() || 1);

      $.ajax({
        url: window.siteUrl + "/cart/add-to-cart",
        method: "POST",
        data: {
          id: productId,
          qty: quantity,
          checkout: 0,
        },
        dataType: "json",
        success: (res) => {
          addNextProduct(index + 1);
        },
        error: (res) => {
          console.error("Error adding product " + productId + " to cart", res);
          addNextProduct(index + 1);
        },
      });
    };

    addNextProduct(0);
  }

  function updateCartDisplay() {
    $.ajax({
      url: window.siteUrl + "/ajax/cart",
      method: "GET",
      success: (response) => {
        if (!response.error) {
          $(".ps-cart--mobile").html(response.data.html);
          $(".cart-item-count").text(response.data.count);

          if (typeof Theme.lazyLoadInstance !== "undefined") {
            Theme.lazyLoadInstance.update();
          }
        }
      },
    });
  }

  function handleSelectAll(e) {
    const isChecked = $(e.target).prop("checked");
    $(".js-select-item").prop("checked", isChecked);
    updateSelectedCount();
  }

  function handleItemSelection() {
    const totalCheckboxes = $(".js-select-item").length;
    const checkedCheckboxes = $(".js-select-item:checked").length;

    if ($selectAllCheckbox.length) {
      if (checkedCheckboxes === 0) {
        $selectAllCheckbox.prop("checked", false).prop("indeterminate", false);
      } else if (checkedCheckboxes === totalCheckboxes) {
        $selectAllCheckbox.prop("checked", true).prop("indeterminate", false);
      } else {
        $selectAllCheckbox.prop("checked", false).prop("indeterminate", true);
      }
    }

    updateSelectedCount();
  }

  function updateSelectedCount() {
    const checkedCheckboxes = $(".js-select-item:checked").length;

    if ($selectedCountElement.length) {
      $selectedCountElement.text(checkedCheckboxes);
    }

    if ($addToCartSelectedBtn.length) {
      $addToCartSelectedBtn.prop("disabled", checkedCheckboxes === 0);
    }

    if ($removeSelectedBtn.length) {
      $removeSelectedBtn.prop("disabled", checkedCheckboxes === 0);
      // remove or add class d-none based on checkedCheckboxes
      if (checkedCheckboxes === 0) {
        $removeSelectedBtn.addClass("d-none");
      } else {
        $removeSelectedBtn.removeClass("d-none");
      }
    }
  }

  function handleDecreaseQuantity(e) {
    const $btn = $(e.currentTarget);
    const $quantityControl = $btn.closest(".quantity-control");
    const $input = $quantityControl.find(".js-quantity-input");
    const currentValue = parseInt($input.val()) || 1;

    if (currentValue > 1) {
      $input.val(currentValue - 1);
      triggerQuantityChange($input);
    }
  }

  function handleIncreaseQuantity(e) {
    const $btn = $(e.currentTarget);
    const $quantityControl = $btn.closest(".quantity-control");
    const $input = $quantityControl.find(".js-quantity-input");
    const currentValue = parseInt($input.val()) || 1;

    $input.val(currentValue + 1);
    triggerQuantityChange($input);
  }

  function triggerQuantityChange($input) {
    const productId = getProductId($input);
    const quantity = parseInt($input.val());

    const event = new CustomEvent("wishlist:quantityChanged", {
      detail: { productId, quantity },
    });
    document.dispatchEvent(event);
  }

  function getProductId($element) {
    const $row = $element.closest(".wishlist-table__row");
    return $row.length ? $row.data("product-id") : null;
  }

  function checkEmptyState() {
    const rows = document.querySelectorAll(".wishlist-table__row");
    if (rows.length === 0) {
      const tableBody = document.querySelector(".wishlist-table__body");
      if (tableBody) {
        const trans = window.Trans;
        tableBody.innerHTML = `
          <div class="wishlist-empty">
            <div class="wishlist-empty__icon">
              <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M40 73.3333C58.4095 73.3333 73.3333 58.4095 73.3333 40C73.3333 21.5905 58.4095 6.66666 40 6.66666C21.5905 6.66666 6.66666 21.5905 6.66666 40C6.66666 58.4095 21.5905 73.3333 40 73.3333Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M29.2 35.3333L35.8667 42L50.8 27" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <h2 class="wishlist-empty__title">${trans["wishlist_empty_title"]}</h2>
            <p class="wishlist-empty__description">${trans["wishlist_empty_description"]}</p>
            <a href="/" class="btn btn--primary btn--large">${trans["wishlist_empty_button"]}</a>
          </div>
        `;
      }
    }
  }

  init();

  $(document)
    .on("click", ".wishlist-table .action-buttons .js-add-to-cart", function (e) {
      e.preventDefault();
      let _self = $(this);
      const row = _self.closest(".wishlist-table__row");
      const productId = _self.data("id");
      const quantityInput = row.find(".js-quantity-input");
      const quantity = parseInt(quantityInput.val() || 1);
      _self.prop("disabled", true).addClass("button-loading");

      $.ajax({
        url: _self.data("url"),
        method: "POST",
        data: {
          id: productId,
          qty: quantity,
          checkout: 0,
        },
        dataType: "json",
        success: (res) => {
          _self.prop("disabled", false).removeClass("button-loading").addClass("active");

          if (res.error) {
            Theme.showError(res.message);
            if (res.data.next_url !== undefined) {
              setTimeout(() => {
                window.location.href = res.data.next_url;
              }, 500);
            }

            return false;
          }

          Theme.showSuccess(res.message);
          quantityInput.val(1);
          const event = new CustomEvent("wishlist:addToCart", {
            detail: { productId, quantity },
          });
          document.dispatchEvent(event);

          if (res.data.next_url !== undefined) {
            window.location.href = res.data.next_url;
          } else {
            $.ajax({
              url: window.siteUrl + "/ajax/cart",
              method: "GET",
              success: (response) => {
                if (!response.error) {
                  $(".ps-cart--mobile").html(response.data.html);
                  $(".cart-item-count").text(response.data.count);

                  if (typeof Theme.lazyLoadInstance !== "undefined") {
                    Theme.lazyLoadInstance.update();
                  }
                }
              },
            });
          }
        },
        error: (res) => {
          _self.prop("disabled", false).removeClass("button-loading");
          Theme.showError(res.message);
        },
      });
    })
    .on("click", ".wishlist-table-js-remove-item", function (e) {
      e.preventDefault();
      let _self = $(this);
      const confirmMessage = _self.data("confirm-message");

      if (!confirm(confirmMessage)) {
        return false;
      }

      const productId = _self.data("id");
      _self.addClass("button-loading");
      $.ajax({
        url: _self.data("url"),
        method: "DELETE",
        success: (res) => {
          if (res.error) {
            _self.removeClass("button-loading");
            Theme.showError(res.message);
            return false;
          }

          Theme.showSuccess(res.message);

          const event = new CustomEvent("wishlist:itemRemoved", {
            detail: { productId },
          });
          document.dispatchEvent(event);

          _self.closest(".wishlist-table__row").remove();
          updateSelectedCount();
          checkEmptyState();
          _self.removeClass("button-loading");
        },
        error: (res) => {
          _self.removeClass("button-loading");
          Theme.showError(res.message);
        },
      });
    });
});
